var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.field.type === "selection"
    ? _c("opt-in-rule-selection", {
        attrs: { field: _vm.field, "unchecked-field": _vm.uncheckedField },
        on: {
          input: function($event) {
            _vm.$emit("input", $event)
          }
        }
      })
    : _c("opt-in-rule-options", {
        attrs: {
          field: _vm.field,
          "unchecked-field": _vm.uncheckedField,
          error: _vm.error
        },
        on: {
          input: function($event) {
            _vm.$emit("input", $event)
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }